import { NavLink, Outlet, Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '@/lib/auth';
import '@/styles/layout.css';
import '@/styles/account.css';

const tabs = [
  { to: '/account', label: 'Workspace', end: true },
  { to: '/account/billing', label: 'Billing' },
  { to: '/account/partners', label: 'Partners' },
];

function SubscriptionBlocker() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleManageBilling = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/stripe/portal", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;
  if (user.email?.toLowerCase().endsWith("@zimamedia.com")) return null;

  const isBlocked =
    user.plan === "starter" ||
    user.subscription_status === "canceled" ||
    user.subscription_status === "past_due" ||
    (!user.subscription_status && user.plan !== "agent");

  if (!isBlocked) return null;

  return (
    <div className="subscription-blocker-overlay">
      <div className="subscription-blocker-modal">
        <div className="billing-blocker-icon">
          <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h3>
          {user.subscription_status === "past_due"
            ? "Payment Issue"
            : "No Active Subscription"}
        </h3>
        <p className="billing-blocker-text">
          {user.subscription_status === "past_due"
            ? "Your payment is past due. Please update your payment method to continue using the platform."
            : "You need an active subscription to access features. Choose a plan to get started."}
        </p>
        <div className="billing-blocker-actions">
          <Link to="/pricing" className="btn btn-primary">
            View Plans
          </Link>
          {user.has_stripe && (
            <button
              className="btn btn-secondary"
              onClick={handleManageBilling}
              disabled={loading}
            >
              {loading ? "Opening..." : "Update Payment"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default function AccountLayout() {
  const location = useLocation();
  const isWorkspaceIndex = location.pathname === '/account' || location.pathname === '/account/';

  return (
    <div className="account-layout">
      {!isWorkspaceIndex && <SubscriptionBlocker />}
      <div className="account-layout-inner">
        <nav className="account-tabs">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                `account-tab${isActive ? ' active' : ''}`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
        <Outlet />
      </div>
    </div>
  );
}
